module.exports = __webpack_public_path__ + "static/media/doodle-website.16c54306.png";